import React from 'react';
import { C } from '../../theme.js';
import { Eyebrow, FieldLabel, TextInput, Select } from '../../components/Primitives.jsx';
import { MultiColsDropdown } from './MultiColsDropdown.jsx';
import { DecimalPlacesField } from '../shared/DecimalPlacesField.jsx';

export function TextStructuralMetricsInspector({ step, onChange }) {
  const c = step.config || {};
  const sel = Array.isArray(c.columns) ? c.columns : [];
  const metrics = Array.isArray(c.metrics) ? c.metrics : ['word_count', 'char_count', 'sentence_count', 'avg_word_length'];
  const suffix = c.suffix || '_{metric}';
  const nullHandling = c.null_handling || 'zero';

  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });

  const toggleMetric = (m) => {
    if (metrics.includes(m)) u({ metrics: metrics.filter(x => x !== m) });
    else u({ metrics: [...metrics, m] });
  };

  const METRIC_LABELS = {
    word_count: 'Word Count',
    char_count: 'Character Count',
    sentence_count: 'Sentence Count',
    avg_word_length: 'Average Word Length'
  };

  return (
    <div>
      <Eyebrow>Structural Text Metrics</Eyebrow>
      <div style={{ color: C.fg4, fontSize: '.78rem', margin: '4px 0 10px', lineHeight: 1.5 }}>
        Extract word count, character count, sentence count, and average word length from text.
      </div>

      <MultiColsDropdown selected={sel} onChange={(v) => u({ columns: v })} stringOnly={true} />

      <div style={{ marginTop: 12 }}>
        <FieldLabel>Metrics to Extract</FieldLabel>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginTop: 4 }}>
          {Object.entries(METRIC_LABELS).map(([k, label]) => (
            <label key={k} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: '.78rem', color: C.fg2, cursor: 'pointer' }}>
              <input 
                type="checkbox" 
                checked={metrics.includes(k)} 
                onChange={() => toggleMetric(k)} 
              />
              {label}
            </label>
          ))}
        </div>
      </div>

      <div style={{ marginTop: 12 }}>
        <FieldLabel hint="Pattern to append to column names. Use {metric} as placeholder.">Output Suffix Pattern</FieldLabel>
        <TextInput 
          value={suffix} 
          onChange={(v) => u({ suffix: v })} 
          placeholder="_{metric}" 
        />
      </div>

      {metrics.includes('avg_word_length') && (
        <div style={{ marginTop: 12 }}>
          <DecimalPlacesField value={c.output_decimals} onChange={(v) => u({ output_decimals: v })} />
        </div>
      )}

      <div style={{ marginTop: 12 }}>
        <FieldLabel hint="How to handle missing or null text values.">Null / Missing Handling</FieldLabel>
        <Select 
          value={nullHandling} 
          onChange={(v) => u({ null_handling: v })}
          options={[
            { value: 'zero', label: 'Treat as 0 / 0.0' },
            { value: 'nan', label: 'Leave as NaN' }
          ]}
        />
      </div>
    </div>
  );
}

